// extracted by mini-css-extract-plugin
export default {"user-info":"UserInfo_user-info__JRHMB","user-info__options":"UserInfo_user-info__options__QHoDK","user-info__button":"UserInfo_user-info__button__9waZY"};